export const emailValidation = email => {
  const reEmail = new RegExp(
    /^[-!#$%&'*+\0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/
  );
  return reEmail.test(email);
};
